import { FcColor, FcElement, FcGridImageData, FcRgb, FcShape } from './fc_common.types'

export enum FcClipped {
  NONE = 0,
  PARTIAL = 1,
  FULL = 2
}

export enum FcPipeType {
  SINGLE = 0,
  CAP = 1,
  COUPLE = 2,
  ELBOW = 3,
  TEE = 4,
  CROSS = 5
}

export interface FcPipeModuleType {
  type: FcPipeType
  rotate: number
}

export interface FcModule {
  row: number
  col: number
  overText?: boolean
  set?: boolean
  clusterNumber?: number
  clusterHole?: number
  checked?: boolean
  color?: FcColor
  shape?: FcShape | null
  type?: FcElement
  gradient?: number
  clipped?: FcClipped
  extendUp?: boolean
  extendDown?: boolean
  erased?: boolean
  pipeErased?: boolean
  forceErased?: boolean
  erasedExact?: boolean
  byteIndex?: number
  rsGroup?: number
  rsAllowedErrors?: number
  inBlend?: boolean
  blendData?: FcGridImageData
  inBlendCanBeErased?: boolean
  inClusterCanBeErased?: boolean
  inBlendPixel?: FcRgb
  inBlendPixelSet?: boolean
  pipeType?: FcPipeModuleType
  isPad?: boolean
  bitIndex?: number
  mask?: boolean
}
